import type { SubscriptionStatus } from "./types"

/** Whether the user may start a trial (backend gate `trial_eligible`). */
export function isTrialEligible(
	status: SubscriptionStatus | null | undefined,
): boolean {
	return status?.trial_eligible === true
}

/** Whether the user is currently inside an active trial period. */
export function isTrialActive(
	status: SubscriptionStatus | null | undefined,
): boolean {
	return status?.trial_active === true
}
